export class Vehiculo {
    public idcompania:string;
    public idvehiculo:string;
    public descripcion:string;
    public tipocombustible:string;
    public tipovehiculo:string;
    public marca:string;
    public modelo:string;
    public kilometraje:number;
}
